import { connect } from 'react-redux';
import Layout from './Layout';

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
  partDocumentTitle: state.header.partDocumentTitle,
});

export default connect(mapStateToProps)(Layout);
